module.exports = __webpack_public_path__ + "img/hourglass-top.54d9f2b9.svg";